<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" (ngSubmit)="save(machineForm.value)" [formGroup]="machineForm">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tbody
            formArrayName="data"
            *ngFor="let item of formData.controls; let i = index"
            class="optimisation-equipment"
          >
            <tr>
              <td class="margin">
                <h2>
                  <span>{{ 'plugins.equipment-info.product-line' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" [formGroupName]="i">
                <div class="ir-form-group">
                  <validation-message
                    [validationControl]="item.controls.ProductLine"
                    [validationName]="'required'"
                    [errorMessage]="'common.required' | translate"
                  ></validation-message>
                  <input type="hidden" name="ProductLine" class="ir-form-set" formControlName="ProductLine" />
                  <div class="ir-line ir-select th-select" (click)="openProductLinesSelector(i)">
                    <div class="ir-line--right">
                      <div class="ir-btn th-btn-modal--content">
                        <i class="material-icons">arrow_drop_down</i>
                      </div>
                    </div>
                    <div class="ir-line-content">
                      <span
                        >{{
                          item.controls.ProductLine.value
                            ? (item.controls.ProductLine.value | productline | async)
                            : ('plugins.equipment-info.select-product-line' | translate)
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </td>
              <td class="th-plugin-line--remove" style="vertical-align: top">
                <i class="material-icons" (click)="remove(i)">remove_circle</i>
              </td>
            </tr>
            <tr>
              <td class="margin">
                <h2>
                  <span>{{ 'plugins.equipment-info.equipment-type' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" [formGroupName]="i">
                <div class="ir-form-group">
                  <validation-message
                    [validationControl]="item.controls.name"
                    [validationName]="'required'"
                    [errorMessage]="'common.required' | translate"
                  ></validation-message>
                  <input type="hidden" name="name" class="ir-form-set" formControlName="name" />
                  <div class="ir-line ir-select th-select" (click)="openModelsSelector(i)">
                    <div class="ir-line--right">
                      <div class="ir-btn th-btn-modal--content">
                        <i class="material-icons">arrow_drop_down</i>
                      </div>
                    </div>
                    <div class="ir-line-content">
                      <span>{{
                        item.controls.name.value
                          ? item.controls.name.value
                          : ('plugins.equipment-info.select-machine' | translate)
                      }}</span>
                    </div>
                  </div>
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <td class="margin">
                <h2>
                  <span>{{ 'plugins.equipment-info.customer-equipment-id' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group" [formGroupName]="i">
                  <validation-message
                    [validationControl]="item.controls.CustomerEquipementId"
                    [validationName]="'required'"
                    [errorMessage]="'common.required' | translate"
                  ></validation-message>
                  <input
                    name="CustomerEquipementId"
                    class="ir-form-set"
                    type="text"
                    formControlName="CustomerEquipementId"
                  />
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <td class="margin">
                <h2>
                  <span>{{ 'plugins.optimization-equipment-info.serial-number' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group" [formGroupName]="i">
                  <validation-message
                    [validationControl]="item.controls.SerialNumber"
                    [validationName]="'required'"
                    [errorMessage]="'common.required' | translate"
                  ></validation-message>
                  <input name="SerialNumber" class="ir-form-set" type="text" formControlName="SerialNumber" />
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <td class="margin">
                <h2>
                  <span>{{ 'plugins.equipment-info.running-hours' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group" [formGroupName]="i">
                  <validation-message
                    [validationControl]="item.controls.RunningHours"
                    [validationName]="'required'"
                    [errorMessage]="'common.required' | translate"
                  ></validation-message>
                  <input
                    name="RunningHours"
                    class="ir-form-set"
                    type="number"
                    min="0"
                    step="1"
                    formControlName="RunningHours"
                  />
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <td class="margin">
                <h2>
                  <span>{{ 'plugins.optimization-equipment-info.total-production' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big">
                <div class="ir-form-group" [formGroupName]="i">
                  <validation-message
                    [validationControl]="item.controls.SheetCount"
                    [validationName]="'required'"
                    [errorMessage]="'common.required' | translate"
                  ></validation-message>
                  <input
                    name="SheetCount"
                    class="ir-form-set"
                    type="number"
                    min="0"
                    step="1"
                    formControlName="SheetCount"
                  />
                </div>
              </td>
              <td></td>
            </tr>
          </tbody>
          <tr class="th-plugin-line--add">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="machineForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
<modal (modalOutput)="selectModelsMenu($event)" (modalClosed)="onClose()" #modelsModal></modal>
<modal
  (modalOutput)="selectProductLinesMenu($event)"
  (modalClosed)="onProductLinesMenuClose($event)"
  #productLinesModal
></modal>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
